// hooks/useConfirmDialog.js
import { useDisclosure } from "@chakra-ui/react";
import { useRef, useState } from "react";

export const useConfirmDialog = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [options, setOptions] = useState({});
  const cancelRef = useRef();

  const confirm = (opts = {}) => {
    return new Promise((resolve) => {
      setOptions({
        title: opts.title || "Are you sure?",
        message: opts.message || "Do you want to proceed?",
        confirmText: opts.confirmText || "Yes",
        cancelText: opts.cancelText || "Cancel",
        onConfirm: () => {
          resolve(true);
          onClose();
        },
        onCancel: () => {
          resolve(false);
          onClose();
        },
      });
      onOpen();
    });
  };

  const dialogProps = { isOpen, onClose, cancelRef, options };

  return { confirm, dialogProps };
};
